<template>
  <div class="margin-top-dollar">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="flex-content">
        <div class="flex-box">
          <div
            v-for="(item, index) in showSidebarPremium"
            :key="'side_'+index"
            class="flex-info">
            <span>{{ item.item }}</span>
            <span>{{ item.premium_str }}</span>
          </div>
          <div class="flex-info">
            <span>MGM Discount</span>
            <el-form-item
              ref="code_disc_prm"
              prop="code_disc_prm">
              <span>
                <v-input
                  v-model.number="formData.code_disc_prm"
                  prepend="-$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div class="flex-info">
            <span>Manual Discount </span>
            <el-form-item
              ref="spec_disc_prm"
              prop="spec_disc_prm">
              <span>
                <v-input
                  v-model.number="formData.spec_disc_prm"
                  prepend="-$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div  class="flex-info">
            <span>Admin Charge</span>
            <el-form-item
              ref="handling_fee"
              prop="handling_fee">
              <span>
                <v-input
                  v-model.number="formData.handling_fee"
                  prepend="+$"
                  :keyFloatNumber="true"
                  maxlength="8"
                  :min="0"
                  @blur="handlerComputed"></v-input>
              </span>
            </el-form-item>
          </div>
          <div
            class="flex-info total-amount">
            <span>{{amountResult.item}}</span>
            <span class="amount">{{ amountResult.premium_str }}</span>
          </div>
        </div>
        <div class="just-end">
          <div class="form-half ">
            <code-select
              v-if="formData.use_code!=0"
              :orderId="orderId"
              :notApply="true"
              :isQuote="false"
              :customerId="customerId"
              :customer="formData.customer"
              :is-user="true"
              :useCode = "formData.use_code"
              @check-code="applyCode"
            ></code-select>
            <!--            <div-->
            <!--              v-if="showReferralSelect"-->
            <!--              class="mg-t-20 mg-b-15 flex">-->
            <!--              &lt;!&ndash;      <span class="fs-14 color-dark fw-600 title margin-left">Referrer Discount</span>&ndash;&gt;-->
            <!--              <v-select-->
            <!--                v-model="referral_id"-->
            <!--                :list="referral_option_list"-->
            <!--                @change="handlerComputed"></v-select>-->
            <!--              <v-button-->
            <!--                gray-->
            <!--                class="mg-l-10"-->
            <!--                @click="handleInitRefer">Default</v-button>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </el-form>
    <coupon-dialog
      ref="coupon-dialog"
      :customerId="customerId"
      :customer="formData.customer"
      :orderId="orderId"
      @coupon="computedCoupon">
    </coupon-dialog>
  </div>
</template>

<script>

import CodeSelect from '@/views/components/code-select'
import CouponDialog from '@/views/quoting/dialogs/coupon-dialog'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapState} from 'vuex'
import {applyOrderCode, verifyPromoCode} from '@api/order'
import {mapActions} from 'vuex'
import MixinRules from '@/mixins/rules'
import MixinReferralOption from '@/mixins/referral-option'
export default {
  name: 'SmePremium',
  components:{
    CodeSelect,
    CouponDialog,
  },
  mixins: [MixinOptions, MixinFormat,MixinRules,MixinReferralOption],
  props:{
    sidebarInfo:{
      type: Object,
      default:()=>({})
    },
    form:{
      type: Object,
      default:()=>({})
    },
    premium:{
      type: Array,
      default:()=>([])
    },
    customerId:{
      type: Number,
      default:''
    },
    orderId:{
      type: Number,
      default:''
    },
  },
  data(){
    return{
      amount: '',
      formData:{
        spec_disc_prm:'',
        handling_fee:'',
        code_disc_prm:'',
        code:'',
        coupon_code:'',
      },
      premium_info:[]
    }
  },
  computed:{
    ...mapState('coupon', ['couponCode','selectCode']),
    package_name(){
      let {package_info={}} = this.sidebarInfo
      let {package_name=''} = package_info
      return package_name
    },
    amountResult() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'paid') {
          total = item||{}
        }
      })
      return total||{}
    },
    handling_fee() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'handling_fee') {
          total = item||{}
        }
      })
      return total||{}
    },
    spec_disc_prm() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'spec_disc_prm') {
          total = item||{}
        }
      })
      return total||{}
    },
    code_disc_prm() {
      let total = {}
      this.sidebarPremium.filter((item)=>{
        if(item.name == 'code_disc_prm') {
          total = item||{}
        }
      })
      return total||{}
    },
    plan_info(){
      let {premium_info} = this.sidebarInfo||{}
      return premium_info||{}
    },
    sidebarPremium() {
      return this.premium||[]
    },
    showSidebarPremium(){
      let arr = this.sidebarPremium.filter(item=>{
        return item.name!='code_disc_prm'&&item.name!='spec_disc_prm'&&item.name!='coupon_vl'&&item.name!='paid'&&item.name!='handling_fee'
      })
      return arr||[]
    }
  },
  watch:{
    form:{
      immediate:true,
      deep:true,
      handler(val){
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] =val[key]
          }
        })
      }
    },
    handling_fee:{
      immediate:true,
      deep:true,
      handler(val){
        let {premium} = val||{}
        this.formData.handling_fee =premium||0
      }
    },
    spec_disc_prm:{
      immediate:true,
      deep:true,
      handler(val){
        let {premium} = val||{}
        this.formData.spec_disc_prm =premium||0
      }
    },
    code_disc_prm:{
      immediate:true,
      deep:true,
      handler(val){
        let {premium} = val||{}
        this.formData.code_disc_prm =premium||0
      }
    }
  },
  methods:{
    ...mapActions('coupon', ['setSelectCode']),
    handleInitRefer(){
      this.handlerComputed()
    },
    handlerComputed(){
      this.$emit('cal',{...this.formData})
    },
    applyCode(){
      this.network().verifyPromoCode()
    },
    computedCoupon(data){
      this.coupon = data
      this.formData.coupon = data
      this.applyCode()
    },
    handlerSetCode(){
      let {coupon,code,coupon_code,referrer, referrer_user_id} = this.form
      let params ={}
      // this.setSelectCode(null)
      if(coupon_code){
        params.coupon = {selectCode:1,...{title:coupon_code,coupon_code}}
        // this.setSelectCode ({selectCode:1,...coupon})
      }
      if(code){
        params.code = {selectCode:2,code, referrer, referrer_user_id}
      }
      this.setSelectCode(params)
    },
    network(){
      return {
        verifyPromoCode: async () => {
          if (this.code) {
            const {data} = await verifyPromoCode({
              customer_id: this.customerId,
              code: this.code
            })
            if (data.code == 1000) {
              this.network().applyOrderCode()
            }
          } else {
            this.network().applyOrderCode()
          }

        },
        applyOrderCode: async () => {
          let {selectCode, coupon = {}, code = {}} = this.selectCode || {}
          let params = {}
          if (coupon.selectCode == 1) {
            params.coupon_code = coupon.coupon_code
          }
          if (code.selectCode == 2) {
            params.code = code.code
          }
          const {dataCode} = await applyOrderCode({
            order_id: this.orderId,
            customer_id: this.customerId,
            ...params
          })
          this.formData.code = params.code
          this.formData.coupon_code = params.coupon_code
          this.formData = {
            ...this.formData,
            ...params
          }
          this.$emit('cal',this.formData)
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.margin-top-dollar{
  .flex-algin{
    //align-items: center;
    margin-bottom: 10px;
    width: 100%;
    .label{
      margin-top: 0;
      word-break: break-word;
    }
    .icon{
      margin-right: 15px;
      height: 22px;
      width: 22px;
      color: #6A737D;
      border-radius: 5px;
      text-align: center;
      img{
        height: 22px;
        width: 22px;
      }
    }
    .icon-content{
      height: 22px;
      width: 22px;
      border-radius: 5px;
      background-color: #E1E4E8;
      color: #6A737D;
      font-size: 14px;
      text-align: center;
      line-height: 22px;
    }
  }
  .flex-content {
    .flex-box {
      border-radius: 5px;
      border: 1px solid #E1E4E8;
      //margin: 16px 0;
      .flex-info {
        display: flex;
        justify-content: space-between;
        padding: 8px 15px;
        border-bottom: 1px solid #E1E4E8;

        span:first-child {
          color: #586069;
          font-size: 14px;
          font-weight:600;
          width: 50%;
        }
        span:last-child {
          color: #24292E;
          font-size: 14px;
          font-weight:400;
        }
      }

      .total-amount {
        background: #f6f8fa;
        border-bottom: 0;
        padding: 20px 15px;
        span{
          font-weight: 600!important;
        }
      }
      .transa-color{
        span{
          color: rgb(205,43,56)!important;
        }

      }

      .amount {
        color: #24292E;
        font-weight: bolder;
      }
    }
  }
  .just-end{
    display: flex;
    justify-content: flex-end;
  }
}

</style>
